module.exports = __webpack_public_path__ + "img/mbbs_fair_mobile.69a2f22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/fair/mbbs_fair_mobile.png
// module id = 1991
// module chunks = 1